import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { GridOptions } from 'ag-grid-community';
import { SurveyValidationErrors } from 'src/app/models/survey-validation-error.model';
import { Surveys } from 'src/app/models/survey.model';
import { TenantJobLog } from 'src/app/models/tenant-job-log.model';
import { TenantJobStepLog } from 'src/app/models/tenant-job-step-log.model';
import { TenantSurveyStatuses } from 'src/app/models/tenant-survey-statuses.model';
import { TenantViewModel } from 'src/app/models/tenant-view-model.model';
import { Tenant } from 'src/app/models/tenant.model';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';
import { DeleteSurveyModalComponent } from '../modals/delete-survey-modal/delete-survey-modal.component';
import { DeleteTenantDataModalComponent } from '../modals/delete-tenant-data-modal/delete-tenant-data-modal.component';
import { DeleteTenantModalComponent } from '../modals/delete-tenant-modal/delete-tenant-modal.component';
import { TenantJobModalComponent } from '../modals/tenant-job-modal/tenant-job-modal.component';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {  
  public gridColumnApi;
  public overlayLoadingTemplate;
  private gridApi;

  tenantDetail = new Tenant();    
  surveyList = new Array<Surveys>();
  jobLogs = new Array<TenantJobLog>();
  jobStepLogs = new Array<TenantJobStepLog>();  
  surveyStatusList = new Array<TenantSurveyStatuses>();
  selectedSurveys = new Array();
  validationError = new Array<SurveyValidationErrors>();

  gridOptions: GridOptions;
  gridOptionsJobLogs: GridOptions;  
  gridOptionsJobStepLogs: GridOptions;
  gridOptionsSurveyValidation: GridOptions;
  tenantName: string;    
  lastRunOutcomeFailed: boolean = false;
  isSurveySelected: boolean = false;
  isJobRunning: boolean = false;
  isJobStuck: boolean = false;
  lastRunOutcome: string;
  currentExecutionStep: string;  
  surveyRunning: number;
  surveyCount: number;
  disableBtn: boolean = false;  
  hideErrorLogs: boolean = true;
  hideValidationError: boolean =  true;

    modalOption: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false
  };

  constructor(private route: ActivatedRoute, private router: Router, private tenantService: TenantService, private modalService: NgbModal) {
    this.gridOptions = <GridOptions>{      
      columnDefs: [
        { headerName: 'Key', field: 'surveyKey', hide: true },
        {
          headerName: 'Survey Versions', 
          field: 'surveyVersionName',          
          headerCheckboxSelection: true,
          checkboxSelection: true,
          tooltipField: 'surveyVersionName',
          width: 150
        }],
      defaultColDef: {
        cellClass: 'table-cell',
        lockPosition: true
      },
      domLayout: 'autoHeight',
      suppressHorizontalScroll: true,
      enableBrowserTooltips: true,
      rowHeight: 40,
      headerHeight: 40,
      suppressCellSelection: true,
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressAggFuncInHeader: true     
    };

    this.gridOptionsJobLogs = <GridOptions>{      
      columnDefs: [
        { headerName: 'Job Name', field: 'jobName', tooltipField: 'jobName', width:50},
        { headerName: 'Job Status', field: 'jobStatus', width:10},
        { headerName: 'Step Name', field: 'step_Name', width:20 },
        { headerName: 'Step Message', field: 'step_Message', tooltipField: 'step_Message', width: 200}
      ],
      defaultColDef: {
        cellClass: 'table-cell',
        lockPosition: true
      },
      enableBrowserTooltips: true,
      rowHeight: 50,
      headerHeight: 40,
      suppressCellSelection: true      
    };

    this.gridOptionsJobStepLogs = <GridOptions>{      
      columnDefs: [
        { headerName: 'Job Step Name', field: 'jobStepName', tooltipField: 'jobStepName', width:30},
        { headerName: 'Step Status', field: 'stepStatus', width:10 },
        { headerName: 'Traceability Id', field: 'traceabilityID', width:20},
        { headerName: 'Step Message', field: 'stepMessage', tooltipField: 'stepMessage', width:200 }
      ],
      defaultColDef: {
        cellClass: 'table-cell',
        lockPosition: true
      },
      enableBrowserTooltips: true,
      rowHeight: 40,
      headerHeight: 40,
      suppressCellSelection: true      
    };

    this.gridOptionsSurveyValidation = <GridOptions>{      
      columnDefs: [       
        { headerName: 'Business Rule', field: 'businessRule', width:10 },
        { headerName: 'Error', field: 'remarks', tooltipField: 'remarks', width: 80}
      ],
      defaultColDef: {
        cellClass: 'table-cell',
        lockPosition: true
      },
      enableBrowserTooltips: true,
      rowHeight: 50,
      headerHeight: 40,
      suppressCellSelection: true      
    };
   }

  ngOnInit(){
    this.tenantName = this.route.snapshot.params['tenantName'];    
    this.getTenantDetails(true);
  }

  getTenantDetails(overrideGridOverlay?: boolean) {
    const self = this;
    self.tenantService.getTenantDetails(this.tenantName).subscribe((getdetails: TenantViewModel) => {
     
      self.tenantDetail = getdetails.tenant;
      self.lastRunOutcomeFailed = getdetails.tenant.isLastRunOutcomeFailed;
      self.surveyList = getdetails.surveys; 
      self.jobLogs = getdetails.tenantJobErrorLogs.jobLogs;
      self.jobStepLogs = getdetails.tenantJobErrorLogs.jobStepLogs;           
      self.lastRunOutcome = getdetails.tenant.lastRunOutcomeStatus;
      self.currentExecutionStep = getdetails.tenant.current_Execution_Step;
      self.surveyCount = getdetails.tenantSurveyStatuses.length;  
      self.isJobRunning = self.surveyCount > 0;
      self.isJobStuck = getdetails.isJobStuck;
      self.surveyRunning = getdetails.tenantSurveyStatuses.filter(s => s.status != 'NotStarted')["length"];
      self.validationError = getdetails.surveyValidationErrors;
    
    if (this.gridOptions.api) {
      self.gridOptions.api.setRowData(self.surveyList);  
      }
    else{
      this.gridOptions.api.setFilterModel(null);
      }
    
    if(this.validationError.length > 0){
      this.gridOptionsSurveyValidation.api.setRowData(self.validationError);   
      this.hideErrorLogs = true;
      this.hideValidationError = false;
    }  
    else if(self.lastRunOutcomeFailed)
    { 
      self.hideErrorLogs = false;
      this.hideValidationError = true;
      self.gridOptionsJobLogs.api.setRowData(self.jobLogs); 
      self.gridOptionsJobStepLogs.api.setRowData(self.jobStepLogs); 
    }   

    if (self.surveyCount > 0 && self.isJobStuck === false) {
      this.hideErrorLogs = true;
      this.hideValidationError = true;
      this.disableBtn = true;
    }
    else{
      this.disableBtn = false;
    }

    if(overrideGridOverlay) {
      this.gridApi.hideOverlay();
    }

    }, (error: any) => {
      this.router.navigate(['/home']);
    });
  }


  //Grid functions============
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }
  
  onGridSizeChangedETL(params) {
    var jobLogsGridWidth = document.getElementById("survey-joblogs");
    var jobStepLogsgridWidth = document.getElementById("survey-jobSteplogs");  
    
    if(jobLogsGridWidth != null){
      this.setDynamicGrid(params, jobLogsGridWidth.offsetWidth);
      this.setDynamicGrid(params, jobStepLogsgridWidth.offsetWidth);
    }      
  } 
  onGridSizeChangedValidation(params){
    var surveyValidationLoggridWidth = document.getElementById("survey-validation");     
    if(surveyValidationLoggridWidth != null){
      this.setDynamicGrid(params, surveyValidationLoggridWidth.offsetWidth);
    }     
  }

setDynamicGrid(params, gridWidth){
  var columnsToShow = [];
  var columnsToHide = [];
  var totalColsWidth = 0;
  var allColumns = params.columnApi.getAllColumns();

  for (var i = 0; i < allColumns.length; i++) {
    let column = allColumns[i];
    totalColsWidth += column.getMinWidth();

    if (totalColsWidth > gridWidth) {
      columnsToHide.push(column.colId);
    } else {
      columnsToShow.push(column.colId);
    }
  }
  params.columnApi.setColumnsVisible(columnsToShow, true);
  params.columnApi.setColumnsVisible(columnsToHide, false);
  params.api.sizeColumnsToFit();
}
  
  
  onSelectionChanged(event) {
    var rowsSelection = this.gridOptions.api.getSelectedRows();
    var rowCount = event.api.getSelectedNodes().length;
    this.isSurveySelected = rowCount > 0 ? true : false;
    this.selectedSurveys = rowsSelection;
  }
 //====================

  refresh(): void {
    this.gridApi.showLoadingOverlay();
    this.refreshSurvey(true);
  }

  refreshSurvey(overrideGridOverlay?: boolean) {
    this.getTenantDetails(overrideGridOverlay);
    this.isSurveySelected = false;
  }

  onDeleteClientTenantButtonClick() {
    const modalRef = this.modalService.open(DeleteTenantModalComponent, this.modalOption);   
    modalRef.componentInstance.tenantName = this.tenantName;
  } 
 
  onRunJobButtonClick(){
    const modalRef = this.modalService.open(TenantJobModalComponent, this.modalOption);   
    modalRef.componentInstance.tenantName = this.tenantName;    
    this.refresh();
    this.disableBtn = true;
  }

  onDeleteSurveyClick() {
    const modalRef = this.modalService.open(DeleteSurveyModalComponent, this.modalOption);    
    modalRef.componentInstance.tenantName = this.tenantName;
    modalRef.componentInstance.surveyKeys = this.selectedSurveys;
    modalRef.result.then(_ => { 
        this.gridApi.showLoadingOverlay();            
        setTimeout(() => {
          this.refreshSurvey(true);                 
         }
         , 3000);              
    });
  }
  onDeleteTenantDataButtonClick() {
    const modalRef = this.modalService.open(DeleteTenantDataModalComponent, this.modalOption);   
    modalRef.componentInstance.tenantName = this.tenantName;
  } 
}
